import { render, staticRenderFns } from "./CompAjuizamentos.vue?vue&type=template&id=e1955ad0&scoped=true&"
import script from "./CompAjuizamentos.vue?vue&type=script&lang=js&"
export * from "./CompAjuizamentos.vue?vue&type=script&lang=js&"
import style0 from "./CompAjuizamentos.vue?vue&type=style&index=0&id=e1955ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1955ad0",
  null
  
)

export default component.exports